module.exports = __webpack_public_path__ + "img/fdtech04.c07612cd.png";